export const iconMap = new Map<string, string>()
  .set('bandage', 'healing')
  .set('bell-outline', 'notifications')
  .set('book-outline', 'book')
  .set('calendar-check', 'calendar_today')
  .set('close', 'close')
  .set('cog-outline', 'settings')
  .set('delete', 'delete')
  .set('delete-outline', 'delete_outline')
  .set('dots-grid', 'drag_indicator')
  .set('dots-vertical', 'more_vert')
  .set('eye-outline', 'visibility')
  .set('file-document-outline', 'description')
  .set('filter-variant', 'filter_list')
  .set('folder-outline', 'folder')
  .set('help-circle-outline', 'live_help')
  .set('home-modern', 'home')
  .set('image-multiple-outline', 'image')
  .set('information-outline', 'info')
  .set('magnify', 'search')
  .set('visibility', 'visibility')
  .set('movie-outline', 'movie')
  .set('note-text-outline', 'event_note')
  .set('patient', 'personal_injury')
  .set('pencil-outline', 'edit')
  .set('plus', 'add')
  .set('share', 'share')
  .set('share-variant-outline', 'share')
  .set('trash-can-outline', 'delete')
  .set('tray-arrow-down', 'file_download')
  .set('view-dashboard-outline', 'grid_view')

  .set('arrow-left', 'arrow_back')
  .set('chevron_right', 'chevron_right')
  .set('chevron_left', 'chevron_left')
  .set('chevron-up', 'expand_less')
  .set('chevron-down', 'expand_more')
  .set('text', 'subject')
  .set('web', 'language')
  .set('account-group-outline', 'groups')
  .set('file-upload-outline', 'upload_file')
  .set('upload', 'file_upload')
  .set('view-list-outline', 'view_list')
  .set('note-plus-outline', 'note_add')
  .set('note-outline', 'note')
  .set('crosshairs-gps', 'gps_fixed')
  .set('transfer', 'transfer_within_a_station')
  .set('attention', 'warning');
